import { oliveFontTokens } from '@ds/tokens'
import { breakpoints } from '../../../../utilities'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    'heading-xs': {
      [breakpoints.lessThan(breakpoints.Sizes.Medium)]: {
        fontSize: '15px',
        lineHeight: '20px',
      },
    },

    'heading-s': {
      textTransform: 'uppercase',

      [breakpoints.lessThan(breakpoints.Sizes.Medium)]: {
        lineHeight: '20px',
      },
    },

    'heading-m': {
      ...tokens.fontHeadingM,
      [breakpoints.lessThan(breakpoints.Sizes.Medium)]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },

    'heading-l': {
      ...oliveFontTokens.fontHeadingL,
    },

    'heading-xl': {
      ...oliveFontTokens.fontHeadingXL,
    },

    'display-xs': {
      [breakpoints.lessThan(breakpoints.Sizes.Medium)]: {
        fontSize: '15px',
        lineHeight: '20px',
      },
    },

    'display-s': {
      [breakpoints.lessThan(breakpoints.Sizes.Medium)]: {
        fontSize: '22px',
        lineHeight: 1.2,
      },
    },

    'display-m': {
      [breakpoints.lessThan(breakpoints.Sizes.Medium)]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },

    'body-m': {
      ...tokens.fontBodyM,
    },
  } as const
}
